export const redirectMaintenance = () => {
  const merchantCode = localStorage.getItem('merchantCode') || 'default';
  const theme = localStorage.getItem('theme') || 'light';

  window.location.href = `/maintenance?merchantCode=${merchantCode}&theme=${theme}`;
};
